<template>
    <div id="modal_component" class="modal-component" v-if="modal">
        <div class="modal-area">
            <div class="modal-overlay">
                <div class="modal-overlay-inside">
                    <div class="modal-outer">
                        <div class="modal-close" @click="hideModal()"></div>
                        <div class="modal-inner">
                            <form @submit.prevent="validate">
                                <p class="p2">You want to withdraw<br class="desktop-only"> {{ coins }} coins</p>
                                <div class="withdraw-warning">
                                    <i class="mdi mdi-alert-outline"></i>
                                    <i>*Before you will transfer your FTOs <br>the first time, please log to your FNWallet</i>
                                </div>
                                <div class="form-actions">
                                    <button class="button--action button--confirm"
                                            type="button"
                                            @click="accept()">
                                        Transfer to wallet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['transfer'],
        computed: {
            coins () {
                return this.$store.getters.modals.withdrawCoins.coins
            },
            modal () {
                return this.$store.getters.modals.withdrawCoins.visible
            }
        },
        methods: {
            accept () {
                this.transfer.process(this.$store.getters.modals.withdrawCoins.type, this.$store.getters.modals.withdrawCoins.coins)
                    .then(() => {
                        let params = {
                            modal: 'withdrawCoins',
                            data: {
                                visible: false,
                                coins: this.$store.getters.modals.withdrawCoins.coins,
                                type: this.$store.getters.modals.withdrawCoins.type,
                                accept: true
                            }
                        }
                        this.$store.commit('modals', params)
                    })

            },
            hideModal () {
                let params = {
                    modal: 'withdrawCoins',
                    data: {
                        visible: false,
                        coins: 0,
                        type: 'mining',
                        accept: false
                    }
                }
                this.$store.commit('modals', params)
            }
        }
    }
</script>
<style>
    .withdraw-warning {
        margin-bottom: 10px;
        
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/modals/WithdrawCoinsModal.vue